import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-postmodern-slime',
  templateUrl: './postmodern-slime.component.html',
  styleUrls: ['./postmodern-slime.component.css']
})
export class PostmodernSlimeComponent implements OnInit {
  galleryItems = [
    { id: 1, type: 'video', url: 'assets/projects/PostmodernSlime/_reel.mp4', title: 'reel.mp4' },
    { id: 2, type: 'video', url: 'assets/projects/PostmodernSlime/amulet.mp4', title: 'amulet.mp4' },
    { id: 3, type: 'image', url: 'assets/projects/PostmodernSlime/amulet.png', title: 'amulet.png' },
    { id: 4, type: 'image', url: 'assets/projects/PostmodernSlime/amulet_detail.png', title: 'amulet_detail.png' },
    { id: 5, type: 'video', url: 'assets/projects/PostmodernSlime/brick.mp4', title: 'brick.mp4' },
    { id: 6, type: 'image', url: 'assets/projects/PostmodernSlime/cat_hair.png', title: 'cat_hair.png' },
    { id: 7, type: 'image', url: 'assets/projects/PostmodernSlime/cat_hair_detail.png', title: 'cat_hair_detail.png' },
    { id: 8, type: 'video', url: 'assets/projects/PostmodernSlime/change.mp4', title: 'change.mp4' },
    { id: 9, type: 'image', url: 'assets/projects/PostmodernSlime/change.png', title: 'change.png' },
    { id: 10, type: 'image', url: 'assets/projects/PostmodernSlime/change_detail.png', title: 'change_detail.png' },
    { id: 11, type: 'video', url: 'assets/projects/PostmodernSlime/covid.mp4', title: 'covid.mp4' },
    { id: 12, type: 'image', url: 'assets/projects/PostmodernSlime/covid.png', title: 'covid.png' },
    { id: 13, type: 'image', url: 'assets/projects/PostmodernSlime/covid_detail.png', title: 'covid_detail.png' },
    { id: 14, type: 'video', url: 'assets/projects/PostmodernSlime/gains.mp4', title: 'gains.mp4' },
    { id: 15, type: 'image', url: 'assets/projects/PostmodernSlime/gains.png', title: 'gains.png' },
    { id: 16, type: 'image', url: 'assets/projects/PostmodernSlime/gains_detail_1.png', title: 'gains_detail_1.png' },
    { id: 17, type: 'image', url: 'assets/projects/PostmodernSlime/gains_detail_2.png', title: 'gains_detail_2.png' },
    { id: 18, type: 'video', url: 'assets/projects/PostmodernSlime/italian.mp4', title: 'italian.mp4' },
    { id: 19, type: 'image', url: 'assets/projects/PostmodernSlime/italian.png', title: 'italian.png' },
    { id: 20, type: 'image', url: 'assets/projects/PostmodernSlime/italian_detail.png', title: 'italian_detail.png' },
    { id: 21, type: 'video', url: 'assets/projects/PostmodernSlime/puzzle.mp4', title: 'puzzle.mp4' },
    { id: 22, type: 'image', url: 'assets/projects/PostmodernSlime/puzzle.png', title: 'puzzle.png' },
    { id: 23, type: 'image', url: 'assets/projects/PostmodernSlime/puzzle_detail.png', title: 'puzzle_detail.png' },
    { id: 24, type: 'video', url: 'assets/projects/PostmodernSlime/sylvia.mp4', title: 'sylvia.mp4' },
    { id: 25, type: 'image', url: 'assets/projects/PostmodernSlime/taco.png', title: 'taco.png' },
    { id: 26, type: 'image', url: 'assets/projects/PostmodernSlime/taco_detail.png', title: 'taco_detail.png' },
    { id: 27, type: 'video', url: 'assets/projects/PostmodernSlime/tums.mp4', title: 'tums.mp4' },
    { id: 28, type: 'image', url: 'assets/projects/PostmodernSlime/tums.png', title: 'tums.png' },
    { id: 29, type: 'image', url: 'assets/projects/PostmodernSlime/tums_detail.png', title: 'tums_detail.png' },
    { id: 30, type: 'image', url: 'assets/projects/PostmodernSlime/uarts.png', title: 'uarts.png' },
    { id: 31, type: 'image', url: 'assets/projects/PostmodernSlime/uarts_detail.png', title: 'uarts_detail.png' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
